module.exports = __webpack_public_path__ + "static/media/dansketext-semibolditalic.8cd8e957.woff";